/* Equipment Express buyer navigation.
   Desktop uses explicit buttons instead of <details> so Empire/theme menu scripts
   cannot intercept the top-level department clicks. Mobile keeps native <details>. */
(() => {
  if (window.__eeBuyerNavBound) return;
  window.__eeBuyerNavBound = true;

  const desktopMQ = window.matchMedia('(min-width: 1024px)');

  const getNav = el => el && el.closest ? el.closest('[data-ee-buyer-nav]') : null;

  function closeDesktopNav(nav, exceptItem = null) {
    if (!nav) return;
    nav.querySelectorAll('[data-ee-buyer-item].is-open').forEach(item => {
      if (item === exceptItem) return;
      item.classList.remove('is-open');
      const toggle = item.querySelector(':scope > [data-ee-menu-toggle]');
      const panel = item.querySelector(':scope > [data-ee-menu-panel]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
    });
  }

  function toggleDesktopItem(toggle) {
    const nav = getNav(toggle);
    const item = toggle.closest('[data-ee-buyer-item]');
    const panel = item && item.querySelector(':scope > [data-ee-menu-panel]');
    if (!nav || !item || !panel) return;

    const opening = !item.classList.contains('is-open');
    closeDesktopNav(nav, item);

    item.classList.toggle('is-open', opening);
    toggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
    panel.hidden = !opening;
  }

  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-ee-menu-toggle]');
    if (toggle && desktopMQ.matches) {
      event.preventDefault();
      event.stopPropagation();
      toggleDesktopItem(toggle);
      return;
    }

    document.querySelectorAll('.ee-buyer-nav--desktop[data-ee-buyer-nav]').forEach(nav => {
      if (!nav.contains(event.target)) closeDesktopNav(nav);
    });
  }, true);

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const nav = getNav(event.target);
    if (!nav) return;
    const openItem = nav.querySelector('[data-ee-buyer-item].is-open');
    if (!openItem) return;
    const toggle = openItem.querySelector(':scope > [data-ee-menu-toggle]');
    closeDesktopNav(nav);
    if (toggle) toggle.focus();
  });

  desktopMQ.addEventListener('change', () => {
    document.querySelectorAll('[data-ee-buyer-nav]').forEach(nav => closeDesktopNav(nav));
    document.querySelectorAll('[data-ee-buyer-menu][open]').forEach(menu => { menu.open = false; });
  });
})();
